
import BaseModuleLayout from "@/components/base/BaseModuleLayout.vue";
import TimetableForm from "@/components/timetable/TimetableForm.vue";
import TimetableResults from "@/components/timetable/TimetableResults.vue";
import { defineComponent } from "vue";

export default defineComponent({
	components: { TimetableForm, TimetableResults, BaseModuleLayout },
	setup() {
		return {};
	},
});
